/*
 * Sign-out button used inside the account navigation menu.
 * Shows progress while the shared sign-out policy clears the accepted session.
 * The native command lease prevents repeated submission without disabling unrelated fields.
 * Example: registerComponents(registry);
 *          <SignOut context={context} label="Sign out"/>
 */

import { UIElement, defineUIElements } from '../../runtime/components/ui-element.js';
import { runSignOut } from './sign-out.js';

export class SignOut extends UIElement {
  static properties = {
    label: {},
    buttonClass: {},
    buttonId: {},
    menuItem: { type: Boolean },
    itemTabIndex: { type: Number },
    onStart: { attribute: false },
    pending: { state: true }
  };

  constructor() {
    super();
    this.label = 'Sign out';
    this.buttonClass = '';
    this.menuItem = false;
    this.itemTabIndex = -1;
    this.pending = false;
  }

  async signOut() {
    this.pending = true;
    try {
      return await runSignOut({ context: this.context, onStart: this.onStart });
    } finally {
      this.pending = false;
    }
  }

  render() {
    return (
      <button
        id={this.buttonId || null}
        type="button"
        class={this.buttonClass || null}
        role={this.menuItem ? 'menuitem' : null}
        tabindex={this.menuItem ? String(this.itemTabIndex) : null}
        data-account-menu-item={this.menuItem ? '' : null}
        command={this.signOut}>
        {this.pending ? 'Signing out…' : this.label}
      </button>
    );
  }
}

export function registerComponents(registry) {
  defineUIElements(registry, { 'tbc-sign-out': SignOut });
}
